import { CheckIcon } from '@heroicons/react/24/solid';
import { CREATOR_STEPS, type CreatorStep } from './use-creator-wizard';

const STEP_LABELS: Record<CreatorStep, string> = {
	purpose: 'Choose purpose',
	content: 'Add content',
	design: 'Design QR code',
	review: 'Download QR code',
};

export function CreatorStepIndicator({ step }: { step: CreatorStep }) {
	const activeIndex = CREATOR_STEPS.indexOf(step);
	return (
		<nav aria-label="QR code creation progress" className="mb-8">
			<ol className="grid grid-cols-4 gap-2">
				{CREATOR_STEPS.map((item, index) => {
					const isCurrent = item === step;
					const isComplete = index < activeIndex;
					return (
						<li key={item} aria-current={isCurrent ? 'step' : undefined} className="min-w-0">
							<div className="flex items-center gap-2">
								<span
									className={`grid size-8 shrink-0 place-items-center rounded-full text-sm font-semibold transition-all duration-200 ${
										isCurrent
											? 'bg-[#0f766e] text-white ring-4 ring-[#0f766e]/20 shadow-xs'
											: isComplete
												? 'bg-emerald-600 text-white'
												: 'bg-slate-100 text-slate-400'
									}`}
								>
									{isComplete ? <CheckIcon className="size-4" /> : index + 1}
								</span>
								<span
									className={`hidden text-sm sm:block transition-colors duration-200 ${
										isCurrent
											? 'font-bold text-[#0f766e]'
											: isComplete
												? 'font-semibold text-slate-800'
												: 'text-slate-400 font-medium'
									}`}
								>
									{STEP_LABELS[item]}
								</span>
							</div>
							<div
								className={`mt-2 h-1 rounded-full transition-all duration-300 ${
									isComplete ? 'bg-emerald-600' : isCurrent ? 'bg-[#0f766e]' : 'bg-slate-200/80'
								}`}
							/>
						</li>
					);
				})}
			</ol>
		</nav>
	);
}
